import { render } from "./salary-certificat.vue?vue&type=template&id=136c29b6"
import script from "./salary-certificat.vue?vue&type=script&lang=js"
export * from "./salary-certificat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__